// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1-Wxa4","card":"_1i0jGs","cardHeading":"_3pptnS","iframeBox":"_1ftMGl"};